import { fetchPaymentUsersApi, fetchpaymentDataByUserIDApi, verifyPaypalTranactionApi, rejectPaypalTransactionApi,
  checkPaypalPaymentApi, paypalPaymentPayToUserApi, giftCouponOnlinePaymentPayUserApi, getCouponsToAsigntoUserByAdminApi} from '../api/paymentApi';
import {requestStarted,requestCompleted} from "./common"


export const setpaymentRequestList =(paymentList) => {
  return {
    type : "SET_PAYMENT_REQUEST_LIST",
    paymentList
  }
}

export const setpaymentDataByTid =(data) =>{
  return {
    type : "SET_PAYMENT_BY_USER_DATA",
    data
  }
}

export const setpaymentDataByTidGiftcouponOnline =(data) =>{
  return {
    type : "SET_GIFTCOUPON_PAYMENT_BY_USER_DATA",
    data
  }
}

export const verifyPaypalTranactionSuccess = (response) =>{
  return{
    type: "SET_VERIYFY_SUCCESS_RESPONSE",
    response
  }
}

export const verifyPaypalTranactionFail = (response) =>{
  return{
    type: "SET_VERIYFY_FAIL_RESPONSE",
    response
  }
}

export const rejectPaypalTranactionSuccess = (response) =>{
  return{
    type: "SET_REJECT_SUCCESS_RESPONSE",
    response
  }
}

export const rejectPaypalTranactionFail = (response) =>{
  return{
    type: "SET_REJECT_FAIL_RESPONSE",
    response
  }
}

export const setpaypalPaymentPayToUser = (data) => {
  return{
    type: "SET_RESPONSE_PAPAL_PAY_USER",
    data
  }
}

export const stopVerifyMessage =() =>{
  return{
    type: "STOP_SHOW_RESPONSE_MESG",
  }
}

export const setpaypalPaymentUser =(data) =>{
  return{
    type: "SET_PAYPAL_PAYMENT_TXN_CHECK",
    data
  }
}



export const fetchpaymentUsers=(token) =>{
    return dispatch =>{
        dispatch(requestStarted());
        fetchPaymentUsersApi(token).then((result) =>{
         dispatch(requestCompleted());
       dispatch(setpaymentRequestList(result));
      });
    }
  }

//fetchpaymentDataByUserID

export const fetchpaymentDataByUserID=(tId, token) =>{
  return dispatch =>{
      dispatch(requestStarted());
      fetchpaymentDataByUserIDApi(tId, token).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setpaymentDataByTid(result));
    });
  }
}

//fetchGiftCouponOnlinePaymentDataByUserID
export const fetchGiftCouponOnlinePaymentDataByUserID=(tId, token) =>{
  return dispatch =>{
      dispatch(requestStarted());
      fetchpaymentDataByUserIDApi(tId, token).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setpaymentDataByTidGiftcouponOnline(result));
    });
  }
}


//verifyPaypalTranaction
export const verifyPaypalTranaction=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      verifyPaypalTranactionApi(data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(verifyPaypalTranactionSuccess(result));
       }else{
        dispatch(verifyPaypalTranactionFail(result));
       }
     
    });
  }
}

//rejectPaypalTransaction
export const rejectPaypalTransaction=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      rejectPaypalTransactionApi(data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(rejectPaypalTranactionSuccess(result));
       }else{
        dispatch(rejectPaypalTranactionFail(result));
       }
    });
  }
}


//paypalPaymentPayToUser
export const paypalPaymentPayToUser=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      paypalPaymentPayToUserApi(data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(setpaypalPaymentPayToUser(result));
       }else{
         alert("error in paypal user pay tranaction");
        //dispatch(rejectPaypalTranactionFail(result));
       }
    });
  }
}


//checkPaypalPayment
export const checkPaypalPayment=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      checkPaypalPaymentApi(data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(setpaypalPaymentUser(result));
       }else{
         alert("error in paypal user pay tranaction");
        //dispatch(rejectPaypalTranactionFail(result));
       }
    });
  }
}

//giftCoupon online ...............

export const verifyGiftCouponOnlineTranactionSuccess = (response) =>{
  return{
    type: "SET_VERIYFY_SUCCESS_GIFTCOUPON_ONLINE_RESPONSE",
    response
  }
}

export const verifyGiftCouponOnlineTranactionFail = (response) =>{
  return{
    type: "SET_VERIYFY_FAIL_GIFTCOUPON_ONLINE_RESPONSE",
    response
  }
}

export const rejectGiftCouonOnlineTranactionSuccess = (response) =>{
  return{
    type: "SET_REJECT_GIFTCOUPON_ONLINE_SUCCESS_RESPONSE",
    response
  }
}

export const rejectGiftCouonOnlineTranactionFail = (response) =>{
  return{
    type: "SET_REJECT_GIFTCOUPON_ONLINE_FAIL_RESPONSE",
    response
  }
}
//stopGiftCouponOnlineVerifyMessage
export const stopGiftCouponOnlineVerifyMessage =() =>{
  return{
    type: "STOP_GIFTCOUPON_ONLINE_RESPONSE_MESG",
  }
}

export const setGiftcouponCountData = (response) =>{
  return{
    type: "SET_GIFTCOUPON_COUNT_DATA",
    response
  }
}

export const setGiftcouponPaymentPayToUser = (response) =>{
  return{
    type: "SET_GIFTCOUPON_PAYMENT_RESPONSE",
    response
  }
}

export const verifyGiftCouponOnlineTransaction=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      verifyPaypalTranactionApi(data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(verifyGiftCouponOnlineTranactionSuccess(result));
       }else{
        dispatch(verifyGiftCouponOnlineTranactionFail(result));
       }
     
    });
  }
}

export const rejectGiftCouponOnlineTransaction=(data) =>{
  return dispatch =>{
      dispatch(requestStarted());
      rejectPaypalTransactionApi(data).then((result) =>{
       dispatch(requestCompleted());
       if(result.success){
        dispatch(rejectGiftCouonOnlineTranactionSuccess(result));
       }else{
        dispatch(rejectGiftCouonOnlineTranactionFail(result));
       }
    });
  }
}

//getCouponsToAsigntoUserByAdmin
export const getCouponsToAsigntoUserByAdmin=(token) =>{
  return dispatch =>{
      dispatch(requestStarted());
      getCouponsToAsigntoUserByAdminApi(token).then((result) =>{
       dispatch(requestCompleted());
     dispatch(setGiftcouponCountData(result));
    });
  }
}


export const giftCouponOnlinePaymentPayUser=(data) =>{
  return dispatch =>{
    dispatch(requestStarted());
    giftCouponOnlinePaymentPayUserApi(data).then((result) =>{
     dispatch(requestCompleted());
    
      dispatch(setGiftcouponPaymentPayToUser(result));
     
  });
}
}


// WEBPACK FOOTER //
// ./src/actions/payment.js